<div class="container-fluid admin-page users-page">
    <header class="admin-page-header">
        <div>
            <h1>{{ 'Users' | translate }}</h1>
            <p>{{ 'Manage administrator profiles and access permissions.' | translate }}</p>
        </div>
        <div class="admin-header-actions">
            @if (canEditUsers) {
                <button (click)="openAddModal()" class="admin-primary-button" type="button">
                    <i class="material-icons">person_add</i><span>{{ 'Add user' | translate }}</span>
                </button>
            }
            <button (click)="loadUsers()" [disabled]="isLoading" class="admin-refresh-button" type="button">
                <i [class.spinning]="isLoading"
                   class="material-icons">refresh</i><span>{{ 'Refresh' | translate }}</span>
            </button>
        </div>
    </header>

    <div class="admin-toolbar">
        <label class="admin-search-field">
            <span>{{ 'Search users' | translate }}</span>
            <div class="admin-search-input">
                <i class="material-icons">search</i>
                <input (ngModelChange)="onSearchChanged($event)" [ngModel]="searchText"
                       [placeholder]="'Username, name or email' | translate" type="search">
            </div>
        </label>
        <div class="admin-toolbar-count">{{ filteredUsers.length }} {{ 'users' | translate }}</div>
    </div>

    @if (isLoading && users.length === 0) {
        <div class="state-card admin-page-state"><i
                class="material-icons spinning">refresh</i><span>{{ 'Loading users...' | translate }}</span></div>
    }
    @if (loadError) {
        <div class="state-card admin-page-state error"><i
                class="material-icons">error_outline</i><span>{{ loadError | translate }}</span></div>
    }
    @if (!isLoading && !loadError && filteredUsers.length === 0) {
        <div class="state-card admin-page-state"><i
                class="material-icons">group_off</i><span>{{ 'No users found.' | translate }}</span></div>
    }

    @if (filteredUsers.length > 0) {
        <div class="users-table-wrap admin-data-table-wrap">
            <table class="users-table admin-data-table">
                <thead>
                <tr>
                    <th [attr.aria-sort]="tableSort.getAriaSort('username')">
                        <button (click)="tableSort.toggle('username')" class="admin-sort-button" type="button">
                            <span>{{ 'Username' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('username', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('username', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('name')">
                        <button (click)="tableSort.toggle('name')" class="admin-sort-button" type="button">
                            <span>{{ 'Name' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('name', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('name', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('email')">
                        <button (click)="tableSort.toggle('email')" class="admin-sort-button" type="button">
                            <span>{{ 'Email' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('email', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('email', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('permissions')">
                        <button (click)="tableSort.toggle('permissions')" class="admin-sort-button" type="button">
                            <span>{{ 'Permissions' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('permissions', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('permissions', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-sort]="tableSort.getAriaSort('lastLogin')">
                        <button (click)="tableSort.toggle('lastLogin')" class="admin-sort-button" type="button">
                            <span>{{ 'Last login' | translate }}</span><span class="admin-sort-indicator">
                                <i [class.active]="tableSort.isDirection('lastLogin', 'asc')" class="material-icons">arrow_drop_up</i>
                                <i [class.active]="tableSort.isDirection('lastLogin', 'desc')" class="material-icons">arrow_drop_down</i>
                            </span>
                        </button>
                    </th>
                    <th [attr.aria-label]="'Actions' | translate"></th>
                </tr>
                </thead>
                <tbody>
                    @for (user of getSortedUsers(); track user.Username) {
                        <tr (click)="openEditModal(user)" (keydown.enter)="openEditModal(user)"
                            class="user-row" tabindex="0">
                            <td [attr.data-label]="'Username' | translate">
                                <div class="username-cell">
                                    <span>{{ user.Username }}</span>@if (isCurrentUser(user)) {
                                        <small>{{ 'You' | translate }}</small>
                                }
                                </div>
                            </td>
                            <td [attr.data-label]="'Name' | translate">{{ user.Name || '-' }}</td>
                            <td [attr.data-label]="'Email' | translate">{{ user.Email || '-' }}</td>
                            <td [attr.data-label]="'Permissions' | translate"><span
                                    class="permission-count">{{ getPermissionCount(user) }}</span></td>
                            <td [attr.data-label]="'Last login' | translate">
                                @if (hasLoggedIn(user)) {
                                    {{ user.LastLoginDate_iso | date:'dd.MM.yyyy HH:mm' }}
                                } @else {
                                    {{ 'Never' | translate }}
                                }
                            </td>
                            <td class="row-actions">
                                @if (canDeleteUsers && !isCurrentUser(user)) {
                                    <button (click)="deleteUser(user, $event)" [title]="'Delete user' | translate"
                                            class="delete-button" type="button">
                                        <i class="material-icons">delete_outline</i><span>{{ 'Delete' | translate }}</span>
                                    </button>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</div>

@if (isAddModalOpen) {
    <app-modal (dismissed)="closeAddModal()" width="min(620px, calc(100vw - 40px))">
        <div class="user-modal">
            <header class="user-modal-header">
                <div><span>{{ 'New administrator' | translate }}</span>
                    <h2>{{ 'Add user' | translate }}</h2></div>
                <button (click)="closeAddModal()" [disabled]="isCreating" class="modal-close" type="button">
                    <i class="material-icons">close</i>
                </button>
            </header>
            @if (!generatedPassword) {
                <form #addUserForm="ngForm" (ngSubmit)="createUser()" class="user-form">
                    <label><span>{{ 'Username' | translate }}</span>
                        <input [(ngModel)]="newUser.Username" autocomplete="off" maxlength="50"
                               minlength="3" name="username" pattern="[A-Za-z0-9._-]+" required>
                        <small>{{ 'Letters, numbers, dot, underscore and dash.' | translate }}</small>
                    </label>
                    <label><span>{{ 'Name' | translate }}</span>
                        <input [(ngModel)]="newUser.Name" autocomplete="off" maxlength="100"
                               minlength="2" name="name" required>
                    </label>
                    <label><span>{{ 'Email' | translate }} <em>{{ 'optional' | translate }}</em></span>
                        <input [(ngModel)]="newUser.Email" autocomplete="off" maxlength="254" name="email" type="email">
                    </label>
                    @if (createError) {
                        <div class="form-message error">{{ createError | translate }}</div>
                    }
                    <footer class="modal-actions">
                        <button (click)="closeAddModal()" [disabled]="isCreating" class="secondary-button"
                                type="button">{{ 'Cancel' | translate }}
                        </button>
                        <button [disabled]="addUserForm.invalid || isCreating" class="primary-button" type="submit">
                            <i class="material-icons">person_add</i><span>{{ (isCreating ? 'Creating...' : 'Create user') | translate }}</span>
                        </button>
                    </footer>
                </form>
            } @else {
                <section class="generated-password-panel">
                    <i class="material-icons success-icon">check_circle</i>
                    <h3>{{ 'User created successfully' | translate }}</h3>
                    <p>{{ 'This password is shown only once. Copy it before closing the modal.' | translate }}</p>
                    <div class="password-value"><code>{{ generatedPassword }}</code>
                        <button (click)="copyGeneratedPassword()" [title]="'Copy password' | translate" type="button"><i
                                class="material-icons">content_copy</i></button>
                    </div>
                    <button (click)="closeAddModal()" class="primary-button" type="button">{{ 'Done' | translate }}
                    </button>
                </section>
            }
        </div>
    </app-modal>
}

@if (editUser) {
    <app-modal (dismissed)="closeEditModal()" width="min(1100px, calc(100vw - 40px))">
        <div class="user-modal edit-user-modal">
            <header class="user-modal-header">
                <div><span>{{ 'Administrator' | translate }}</span>
                    <h2>{{ editUser.Username }}</h2></div>
                <button (click)="closeEditModal()" [disabled]="isSaving || isResettingPassword" class="modal-close"
                        type="button">
                    <i class="material-icons">close</i>
                </button>
            </header>
            <form #editUserForm="ngForm" (ngSubmit)="saveUser()" class="user-form edit-form">
                <section class="profile-fields">
                    <label><span>{{ 'Name' | translate }}</span>
                        <input [(ngModel)]="editUser.Name" [disabled]="!canEditUsers || isResettingPassword"
                               maxlength="100"
                               minlength="2" name="editName" required>
                    </label>
                    <label><span>{{ 'Email' | translate }} <em>{{ 'optional' | translate }}</em></span>
                        <input [(ngModel)]="editUser.Email" [disabled]="!canEditUsers || isResettingPassword"
                               maxlength="254"
                               name="editEmail" type="email">
                    </label>
                </section>

                @if (canResetPasswords) {
                    <section class="password-reset-section">
                        <div class="password-reset-heading">
                            <i class="material-icons">lock_reset</i>
                            <div>
                                <h3>{{ 'Reset password' | translate }}</h3>
                                <p>{{ 'Generate and save a new secure password for this administrator.' | translate }}</p>
                            </div>
                        </div>
                        @if (resetGeneratedPassword) {
                            <div class="password-reset-result">
                                <strong>{{ 'Password reset successfully' | translate }}</strong>
                                <p>{{ 'This password is shown only once. Copy it before closing the modal.' | translate }}</p>
                                <div class="password-value"><code>{{ resetGeneratedPassword }}</code>
                                    <button (click)="copyResetPassword()" [title]="'Copy password' | translate"
                                            type="button">
                                        <i class="material-icons">content_copy</i>
                                    </button>
                                </div>
                            </div>
                        } @else {
                            <button (click)="resetUserPassword()" [disabled]="isResettingPassword || isSaving"
                                    class="reset-password-button" type="button">
                                <i [class.spinning]="isResettingPassword" class="material-icons">
                                    {{ isResettingPassword ? 'refresh' : 'lock_reset' }}
                                </i>
                                <span>{{ (isResettingPassword ? 'Resetting...' : 'Reset password') | translate }}</span>
                            </button>
                        }
                        @if (resetPasswordError) {
                            <div class="form-message error">{{ resetPasswordError | translate }}</div>
                        }
                    </section>
                }

                <section class="permissions-section">
                    <div class="permissions-heading">
                        <div><h3>{{ 'Permissions' | translate }}</h3>
                            <p>{{ 'Select the actions and data this administrator can access.' | translate }}</p></div>
                        <span>{{ getSelectedPermissionCount() }} {{ 'selected' | translate }}</span>
                    </div>
                    @if (isEditingCurrentUser()) {
                        <div class="self-permission-notice"><i class="material-icons">lock</i>
                            <span>{{ 'You cannot edit your own permissions.' | translate }}</span></div>
                    }
                    <p>{{ 'You can only grant or remove permissions you have yourself.' | translate }}</p>
                    <div class="permission-groups">
                        @for (group of permissionGroups; track group) {
                            <section class="permission-group">
                                <h4>{{ group | translate }}</h4>
                                <div class="permission-grid">
                                    @for (definition of getPermissionDefinitions(group); track definition.permission) {
                                        <label [class.checked]="hasPermission(definition.permission)"
                                               class="permission-option">
                                            <input (change)="togglePermission(definition.permission, $any($event.target).checked)"
                                                   [checked]="hasPermission(definition.permission)"
                                                   [disabled]="!canTogglePermission(definition.permission)"
                                                   type="checkbox">
                                            <span><strong>{{ definition.label | translate }}</strong><small>{{ definition.permission }}</small>
                                                <em>{{ definition.description | translate }}</em></span>
                                        </label>
                                    }
                                </div>
                            </section>
                        }
                    </div>
                </section>

                @if (editMessage) {
                    <div [class.error]="editMessageType === 'error'"
                         class="form-message">{{ editMessage | translate }}
                    </div>
                }
                <footer class="modal-actions">
                    <button (click)="closeEditModal()" [disabled]="isSaving || isResettingPassword"
                            class="secondary-button" type="button">{{ 'Close' | translate }}
                    </button>
                    @if (canEditUsers) {
                        <button [disabled]="editUserForm.invalid || isSaving || isResettingPassword"
                                class="primary-button" type="submit">
                            <i class="material-icons">save</i><span>{{ (isSaving ? 'Saving...' : 'Save changes') | translate }}</span>
                        </button>
                    }
                </footer>
            </form>
        </div>
    </app-modal>
}
